export const faqs = [
  {
    question:
      'I lost my secret can I still withdraw my funds?',
    answer:
      'Unfortunately no. By design and for your privacy there are random numbers generated during depositing that are not stored anywhere'
  },
  {
    question:
      'Why does the withdrawal take so long?',
    answer:
      'This is because we are generating a ZK-snark proof. This is computational heavy and uses Web Assembly to accomplish that....Which is unrelated to your question but like super cool.'
  },
  {
    question:
      'Why I should use mixer? isnt blockchain private enough?',
    answer:
      'There is a level of privacy with blockchain. However a lot of DApps require a human element and you can tie an account to an identity, since everything on the blockchain is on a ledger you can tie all accounts together. The mixer can help you have an account with funds without a history that connects all your accounts'
  },
  {
    question:
      'So how private is this?',
    answer:
      'It isn\'s a blackbox. All transactions still appear on the blockchain. However this turns one input to one output from many inputs to many outputs.'
  },
  {
    question:
      'Is there anything I can do to make it more private?',
    answer:
      'Absolutely! Two things are needed here for privacy. Liquidity, the more people using it the more private and increased time between your deposit and your withdrawal'
  },
  {
    question:
      'So who actually built this?',
    answer:
      'This was built each piece by many teams. Special things to Oliver from the Argent team, Harry for Ethsnarks and the WASM piece, WJ and Moloch for putting this all together'
  },
];
